import { smartRound } from '@/shared/lib/math'
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  MinusOutlined,
} from '@ant-design/icons'
import { Flex } from 'antd'
import { useUnit } from 'effector-react'

import {
  $registrationDynamicsCourse,
  $registrations,
} from '../../model/statistics-app-data.model'
import { StatisticsSectionWrapper } from '../StatisticsSectionWrapper'

interface RegistrationsTrendProps {
  displayBottom?: boolean
}

export const RegistrationsTrend = ({
  displayBottom = true,
}: RegistrationsTrendProps) => {
  const registrations = useUnit($registrations)
  const registrationDynamicsCourse = useUnit($registrationDynamicsCourse)
  const count = registrations.registrationsCount
  const dynamics = Math.abs(smartRound(registrations.dynamics))
  const trend = registrationDynamicsCourse

  const TotalIcon = {
    positive: ArrowUpOutlined,
    neutral: MinusOutlined,
    negative: ArrowDownOutlined,
  }[registrationDynamicsCourse]

  const DynamicsIcon = {
    positive: CaretUpOutlined,
    neutral: MinusOutlined,
    negative: CaretDownOutlined,
  }[registrationDynamicsCourse]

  const iconColor = {
    positive: '#52C41A',
    neutral: '#FAAD14',
    negative: '#FF4D4F',
  }

  const middle = (
    <Flex style={{ fontSize: '30px', fontWeight: '600' }} align="center">
      <span>{count}</span>
      <TotalIcon style={{ color: iconColor[trend], marginLeft: 4 }} />
    </Flex>
  )

  const bottom = displayBottom ? (
    <>
      <span>динамика {dynamics}%</span>
      <DynamicsIcon style={{ color: iconColor[trend], marginLeft: 4 }} />
    </>
  ) : (
    <div />
  )

  return (
    <StatisticsSectionWrapper
      title="Регистрации пользователей"
      middle={middle}
      bottom={bottom}
    />
  )
}
